import { useState, useEffect } from "react";
import { fetchAPI } from "../config/api";

export const useGameData = (year, gameId) => {
    const [gameData, setGameData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      const controller = new AbortController();

      (async () => {
        setLoading(true);
        setError(null);
        try {
          const data = await fetchAPI(`/api/games/${year}/${gameId}`, { signal: controller.signal });
          if (!controller.signal.aborted) {
            setGameData({ ...data, plays: data.plays });
          }
        } catch (e) {
          if (e.name !== "AbortError") {
            setError("Failed to load game data");
          }
        } finally {
          if (!controller.signal.aborted) {
            setLoading(false);
          }
        }
      })();

      return () => controller.abort();
    }, [year, gameId]);
  
    return { gameData, loading, error };
  };